export enum TechAbilityEnum {
    FIXED = 'FIXED',
    MOBILE = 'MOBILE',
    BOTH = 'BOTH',
    NONE = 'NONE',
    REFINEMENT_FIXED_ONLY = 'REFINEMENT_FIXED_ONLY',
    REFINEMENT_WITH_MOBILE = 'REFINEMENT_WITH_MOBILE',
}
